module.exports = __webpack_public_path__ + "static/media/login-bkgd-1.7b5c1669.png";